import { WebEventing } from '@astrid/eventing'

export class Analytics {
  static identify(userId: string, traits: object) {
    analytics.identify(userId, traits)
  }

  static page() {
    analytics.page()
  }

  static track(event: WebEventing.Event<object>) {
    analytics.track(event.name, event.props)
  }
}
